import { AppContent } from '../AppContent';

const aboutBusiness: AppContent['aboutBusiness'] = {
  aboutBusinessContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'About the business',
      info: 'You’ll have access to all the accounts for this business.',
      continueBtn: 'Continue',
      continueBtnHref: '/dummy-page',
      previousLabel: 'Previous',
      previousHref: '/approve-your-registration',
      warningTextForRegister:
        'It’s not possible to register with this type of account.',
      warningTextForSortCode:
        'Please try a different sort code and account number.',
      errorHeading: 'Please correct these fields.',
      enterBusinessName: 'Enter a business name',
      businessNameContains: `Make sure the business name only contains these special characters: _@&+-./'()`,
      businessNameMaxText:
        'Please ensure that the length of your input is less than 121 characters in length',
      businessNameLabel: 'Business name',
      businessNameSupportText:
        'Enter the name as it appears on the bank statement or business debit card',
      enterSortCode: 'Enter a sort code',
      sortCodeDigits: 'Sort code should be 6 digits',
      startsWith_1: '12',
      startsWith_2: '80',
      enterBrandCode: 'Enter a Bank of Scotland sort code',
      sortCodeLabel: 'Sort code',
      enterAccountNumber: 'Enter an account number',
      accountNumberDigits: 'Account number should be 8 digits',
      accountNumberLabel: 'Account number',
      ocisErrorInfo:
        'We couldn’t find your account. Please check the details and try again.',
      orCallUsOn: 'Or call us on',
      ocisHelpContact: '0345 300 0268',
      forSomeHelp: 'for some help.',
      mayfairErrorPagePath: '/mayfair-account',
      aboutYouPagePath: '/about-you',
      technicalErrorPageHref: '/technical-error',
    },
  ],
};

export default aboutBusiness;
